import type { TourShare } from '@carboncopyco/types';
import { Toggle, TooltipBubble } from '@carboncopyco/ui';
import { isFuture, useTourAnalytics } from '@carboncopyco/utils';

export const LinkToggle = ({
  link,
  onToggle,
}: {
  link: TourShare;
  onToggle: (link: TourShare) => void;
}) => {
  const { entityId, isActive, options } = link;

  const { trackTourClickDeactivateShare, trackTourClickActivateShare } =
    useTourAnalytics({
      location: 'tour_info_page_shares_tab_table',
      tourId: entityId,
    });

  const checked =
    isActive && (!options.expiresAt || isFuture(options.expiresAt));

  return (
    <TooltipBubble
      title={checked ? 'Link is active' : 'Link is inactive'}
      placement="top"
      offset={[0, 10]}
    >
      <div className="mr-6">
        <Toggle
          checked={checked}
          onChange={() => {
            isActive
              ? trackTourClickDeactivateShare()
              : trackTourClickActivateShare();
            onToggle(link);
          }}
        />
      </div>
    </TooltipBubble>
  );
};
